import { URL_OPENREC_TV } from "constants/URL"

export type UserParams = Readonly<{
    id: string
}>

export class User implements UserParams {
    readonly id: string

    private constructor(params: UserParams) {
        this.id = params.id

        Object.freeze(this)
    }
    
    static of(params: UserParams): User {
        if (params instanceof User) {
            return params
        } else {
            return new User(params)
        }
    }

    get subsUrl(): string  {
        return `${URL_OPENREC_TV}/subscription/user/${this.id}`
    }
}

